"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _i18n = require("../../../../../Framework/i18n");
var _reactFileDrop = _interopRequireDefault(require("react-file-drop"));
var _styles = require("@material-ui/core/styles");
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));
var _Image = _interopRequireDefault(require("@material-ui/icons/Image"));
var _CheckCircle = _interopRequireDefault(require("@material-ui/icons/CheckCircle"));
var _Error = _interopRequireDefault(require("@material-ui/icons/Error"));
var _Loop = _interopRequireDefault(require("@material-ui/icons/Loop"));
var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));
var _FormGroup = _interopRequireDefault(require("@material-ui/core/FormGroup"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _MainButton = _interopRequireDefault(require("../../../../../Shared/Components/MainButton"));
var _ServiceLocator = require("../../../../ServiceLocator");
var _withWidth = _interopRequireWildcard(require("@material-ui/core/withWidth"));
var _configuration = require("../../../../configuration");
var _DesignDataService = require("../../../../Services/DesignDataService");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var styles = function styles(theme) {
  var _imagePreview, _imageUploadDropZone, _imageUploadContainer, _imageUploadButton, _imageUploadTextSucce;
  return {
    imagePreview: (_imagePreview = {
      maxWidth: 400,
      maxHeight: 200
    }, _defineProperty(_imagePreview, theme.breakpoints.down('sm'), {
      maxWidth: 300,
      maxHeight: 160
    }), _defineProperty(_imagePreview, "resizeMode", 'contain'), _defineProperty(_imagePreview, "boxShadow", theme.shadows[4]), _imagePreview),
    imageUploadDropZone: (_imageUploadDropZone = {
      background: 'white',
      height: 335,
      width: 450,
      border: '1px dashed #ccc',
      borderRadius: 4,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }, _defineProperty(_imageUploadDropZone, theme.breakpoints.down('sm'), {
      width: 'auto'
    }), _defineProperty(_imageUploadDropZone, theme.breakpoints.down('xs'), {
      height: 300
    }), _imageUploadDropZone),
    imageUploadContainer: (_imageUploadContainer = {
      background: 'white',
      width: '100%',
      margin: 30,
      borderRadius: 4
    }, _defineProperty(_imageUploadContainer, theme.breakpoints.down('xs'), {
      margin: 16
    }), _defineProperty(_imageUploadContainer, "display", 'flex'), _defineProperty(_imageUploadContainer, "flexDirection", 'column'), _defineProperty(_imageUploadContainer, "alignItems", 'center'), _imageUploadContainer),
    imageUploadIcon: {
      fontSize: 30,
      marginRight: 5,
      color: theme.palette.primary.darkText
    },
    imageUploadIconError: {
      fontSize: 50,
      marginBottom: 5,
      color: 'red'
    },
    imageUploadIconSuccess: {
      color: '#4FC36D'
    },
    imageUploadButton: (_imageUploadButton = {
      fontSize: 15
    }, _defineProperty(_imageUploadButton, theme.breakpoints.down('xs'), {
      padding: '0 24px',
      height: 56
    }), _defineProperty(_imageUploadButton, '& input', {
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      opacity: 0,
      '&:hover': {
        cursor: 'pointer'
      }
    }), _imageUploadButton),
    imageUploadOwnership: _defineProperty({
      padding: '20px 0px 20px 12px',
      maxWidth: 450,
      minHeight: 65,
      '& span': {
        fontSize: 15
      }
    }, theme.breakpoints.down('sm'), {
      width: 'auto'
    }),
    imageUploadOwnershipCheckbox: {
      marginBottom: 'auto',
      padding: '0 12px'
    },
    colorChecked: {
      '& svg': {
        color: theme.palette.primary.main
      }
    },
    imageUploadChangeImageButton: {
      textTransform: 'none',
      fontWeight: 'bold'
    },
    imageUploadText: _defineProperty({
      margin: '0 100px',
      marginBottom: 10,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      textAlign: 'center',
      width: '100%'
    }, theme.breakpoints.down('sm'), {
      marginLeft: 0,
      marginRight: 0
    }),
    imageUploadTextError: {
      color: 'red',
      margin: '0 45px 20px'
    },
    imageUploadTextSuccess: (_imageUploadTextSucce = {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      textAlign: 'left'
    }, _defineProperty(_imageUploadTextSucce, theme.breakpoints.down('sm'), {
      marginLeft: 0,
      marginRight: 0
    }), _defineProperty(_imageUploadTextSucce, "color", '#4FC36D'), _defineProperty(_imageUploadTextSucce, "fontWeight", 'bold'), _imageUploadTextSucce),
    termsAndConditionsLink: {
      color: 'black'
    },
    ownershipError: {
      color: '#f00',
      paddingLeft: 36,
      textAlign: 'initial'
    },
    uploadTextIconContainer: {
      flexDirection: 'row',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: 10,
      marginBottom: 10,
      width: '100%',
      alignSelf: 'center'
    },
    checkerBackground: {
      backgroundImage: 'linear-gradient(45deg, #F0F0F0 25%, transparent 25%), ' + 'linear-gradient(-45deg, #F0F0F0 25%, transparent 25%), ' + 'linear-gradient(45deg, transparent 75%, #F0F0F0 75%), ' + 'linear-gradient(-45deg, transparent 75%, #F0F0F0 75%)',
      backgroundSize: '20px 20px',
      backgroundPosition: '0 0, 0 10px, 10px -10px, -10px 0px'
    }
  };
};
var ImageEditDialog = /*#__PURE__*/function (_React$Component) {
  _inherits(ImageEditDialog, _React$Component);
  var _super = _createSuper(ImageEditDialog);
  function ImageEditDialog(props) {
    var _this;
    _classCallCheck(this, ImageEditDialog);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "handleInputChange", function (evt) {
      return _this.updateFile(evt.target.files[0]);
    });
    _defineProperty(_assertThisInitialized(_this), "handleDrop", function (files) {
      return _this.updateFile(files[0]);
    });
    _defineProperty(_assertThisInitialized(_this), "handleUpload", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(image) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _DesignDataService.calculateImageBrightness)(image);
            case 2:
              return _context.abrupt("return", _context.sent);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "updateFile", function (file) {
      if (!file) {
        return;
      }
      var _this$props = _this.props,
        uploadSize = _this$props.uploadSize,
        onValidate = _this$props.onValidate;
      var error = null;
      if (file.size > uploadSize) {
        var maxUploadSize = parseFloat((uploadSize / Math.pow(1024, Math.floor(Math.log(uploadSize) / Math.log(1024)))).toFixed(2));
        error = (0, _i18n.t)('fileUpload.uploadSizeError', {
          uploadSize: maxUploadSize
        });
      }
      var extension = file.name.toLowerCase().match(/\.([0-9a-z]+)$/i)[1];
      var allowedFormats = (0, _configuration.getConf)('designer.allowedImageUploadFormats').split(',');
      if (allowedFormats.indexOf(extension) === -1) {
        error = (0, _i18n.t)('fileUpload.uploadFormatError', {
          formats: allowedFormats.join(', ').toUpperCase()
        });
      }
      onValidate && onValidate({
        isValid: !error,
        error: error
      });
      _this.setState({
        ownershipErrorVisible: false,
        selectedFile: file,
        error: error,
        imageData: null
      });
      var renderableFormats = ['jpg', 'jpeg', 'svg', 'png', 'bmp', 'gif'];
      var isRenderable = renderableFormats.indexOf(extension) !== -1;
      if (isRenderable && file.type && file.type.match('image.*')) {
        var reader = new FileReader();
        reader.onload = /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(e) {
            var image;
            return _regeneratorRuntime().wrap(function _callee3$(_context3) {
              while (1) switch (_context3.prev = _context3.next) {
                case 0:
                  image = new Image();
                  image.onload = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
                    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                      while (1) switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return _this.handleUpload(image);
                        case 2:
                          image = _context2.sent;
                          _this.setState({
                            imageData: image
                          });
                        case 4:
                        case "end":
                          return _context2.stop();
                      }
                    }, _callee2);
                  }));
                  image.src = e.target.result;
                case 3:
                case "end":
                  return _context3.stop();
              }
            }, _callee3);
          }));
          return function (_x2) {
            return _ref2.apply(this, arguments);
          };
        }();
        reader.readAsDataURL(file);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleImageOwnershipChange", function (event, checked) {
      _this.setState({
        ownershipErrorVisible: false,
        ownershipChecked: checked
      });
    });
    _defineProperty(_assertThisInitialized(_this), "uploadFile", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var _this$state, ownershipChecked, selectedFile, checkOwnership, onUploadFinished;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _this$state = _this.state, ownershipChecked = _this$state.ownershipChecked, selectedFile = _this$state.selectedFile;
            checkOwnership = _this.props.checkOwnership;
            if (selectedFile) {
              _context4.next = 4;
              break;
            }
            return _context4.abrupt("return");
          case 4:
            if (!(checkOwnership && !ownershipChecked)) {
              _context4.next = 8;
              break;
            }
            _this.setState({
              ownershipErrorVisible: true
            });
            if (_this.ownershipGroup && _this.ownershipGroup.current && typeof _this.ownershipGroup.current.scrollIntoView === 'function') {
              _this.ownershipGroup.current.scrollIntoView();
            }
            return _context4.abrupt("return");
          case 8:
            // reset the error before the next upload
            _this.setState({
              error: null
            });
            _context4.prev = 9;
            _context4.next = 12;
            return _ServiceLocator.Services.designer.uploadFile(selectedFile);
          case 12:
            if (_this.dropZone.current && _this.dropZone.current && typeof _this.dropZone.current.scrollIntoView === 'function') {
              _this.dropZone.current.scrollIntoView();
            }
            onUploadFinished = _this.props.onUploadFinished;
            onUploadFinished && onUploadFinished();
            _context4.next = 21;
            break;
          case 17:
            _context4.prev = 17;
            _context4.t0 = _context4["catch"](9);
            // eslint-disable-next-line no-console
            console.error(_context4.t0);
            _this.setState({
              error: (0, _i18n.t)('fileUpload.processingFailed')
            });
          case 21:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[9, 17]]);
    })));
    _defineProperty(_assertThisInitialized(_this), "getAllowedImageFormats", function () {
      var formats = (0, _configuration.getConf)('designer.allowedImageUploadFormats').split(',');
      return formats ? formats.map(function (format) {
        return ".".concat(format);
      }) : 'image/*';
    });
    _this.state = {
      selectedFile: null,
      ownershipChecked: false,
      ownershipErrorVisible: false,
      error: null,
      imageData: null
    };
    _this.ownershipGroup = /*#__PURE__*/_react["default"].createRef();
    _this.dropZone = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }
  _createClass(ImageEditDialog, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        classes = _this$props2.classes,
        width = _this$props2.width,
        checkOwnership = _this$props2.checkOwnership;
      var _this$state2 = this.state,
        ownershipChecked = _this$state2.ownershipChecked,
        ownershipErrorVisible = _this$state2.ownershipErrorVisible,
        selectedFile = _this$state2.selectedFile,
        error = _this$state2.error,
        imageData = _this$state2.imageData;
      return /*#__PURE__*/_react["default"].createElement(_reactFileDrop["default"], {
        onDrop: this.handleDrop,
        draggingOverTargetClassName: 'draggingOverDropZone',
        accept: "image/jpeg,image/jpg,image/tiff,image/gif",
        multiple: false
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.imageUploadDropZone,
        ref: this.dropZone
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.imageUploadContainer
      }, selectedFile === null && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        className: classes.imageUploadIcon
      }), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        className: classes.imageUploadText,
        variant: "body2"
      }, (0, _i18n.t)((0, _withWidth.isWidthDown)('sm', width) ? 'fileUpload.uploadFiles' : 'fileUpload.dragDropFiles')), /*#__PURE__*/_react["default"].createElement(_MainButton["default"], {
        onClick: function onClick() {},
        variant: "contained",
        className: classes.imageUploadButton
      }, (0, _i18n.t)('fileUpload.chooseImage'), /*#__PURE__*/_react["default"].createElement("input", {
        type: "file",
        accept: this.getAllowedImageFormats(),
        onChange: this.handleInputChange
      }))), selectedFile !== null && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, imageData && /*#__PURE__*/_react["default"].createElement("img", {
        className: "".concat(classes.imagePreview, " ").concat(imageData.isBright ? classes.checkerBackground : ''),
        src: imageData.src
      }), error === null ? /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.uploadTextIconContainer
      }, /*#__PURE__*/_react["default"].createElement(_CheckCircle["default"], {
        className: "\n                                                ".concat(classes.imageUploadIcon, "\n                                                ").concat(classes.imageUploadIconSuccess, "\n                                            ")
      }), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        variant: "body2",
        className: classes.imageUploadTextSuccess
      }, selectedFile.name)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Error["default"], {
        className: classes.imageUploadIconError
      }), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        variant: "body2",
        className: "\n                                                        ".concat(classes.imageUploadText, "\n                                                        ").concat(classes.imageUploadTextError, "\n                                             ")
      }, error)), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        variant: "body2",
        className: classes.imageUploadText
      }, (0, _i18n.t)((0, _withWidth.isWidthDown)('sm', width) ? 'fileUpload.changeFiles' : 'fileUpload.dragDropFiles')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        onClick: function onClick() {},
        variant: "text",
        className: "".concat(classes.imageUploadButton, " ").concat(classes.imageUploadChangeImageButton)
      }, /*#__PURE__*/_react["default"].createElement(_Loop["default"], null), " ", (0, _i18n.t)('fileUpload.changeImage'), /*#__PURE__*/_react["default"].createElement("input", {
        type: "file",
        accept: this.getAllowedImageFormats(),
        onChange: this.handleInputChange
      }))))), checkOwnership && /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
        classes: {
          root: classes.imageUploadOwnership
        },
        ref: this.ownershipGroup
      }, /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
        control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
          classes: {
            root: classes.imageUploadOwnershipCheckbox,
            checked: classes.colorChecked
          },
          checked: ownershipChecked,
          onChange: this.handleImageOwnershipChange,
          disabled: false
        }),
        label: /*#__PURE__*/_react["default"].createElement("span", {
          dangerouslySetInnerHTML: {
            __html: (0, _i18n.t)('fileUpload.confirmImageOwnership')
          }
        })
      }), ownershipErrorVisible && /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        variant: "body2",
        className: classes.ownershipError
      }, (0, _i18n.t)('fileUpload.imageOwnershipError'))));
    }
  }]);
  return ImageEditDialog;
}(_react["default"].Component);
_defineProperty(ImageEditDialog, "defaultProps", {
  checkOwnership: true
});
var _default = exports["default"] = (0, _withWidth["default"])({
  initialWidth: 'lg'
})((0, _styles.withStyles)(styles, {
  name: 'ImageEditDialog'
})(ImageEditDialog));